// Getters
export const professionals = (state) => {
  return state.professionals.data || []
}
export const professionalsByCode = (state) => {
  const list = state.professionals.data || []
  return list.reduce((map, item) => {
    if (item && item.codigo_assessor) {
      map[item.codigo_assessor] = item
    }
    return map
  }, {})
}
export const professionalsLoading = (state) => {
  return state.professionals.loading
}
export const professionalsLastUpdate = (state) => {
  return state.professionals.lastUpdate
}
export const professionalsIsActive = (state) => {
  return state.professionals.isActive
}

export const allProfessionals = (state) => {
  return state.allProfessionals.data || []
}
export const allProfessionalsLoading = (state) => {
  return state.allProfessionals.loading
}
export const allProfessionalsLastUpdate = (state) => {
  return state.allProfessionals.lastUpdate
}
export const allProfessionalsIsActive = (state) => {
  return state.allProfessionals.isActive
}

export const churn = (state) => {
  return state.churn.data || []
}
export const churnLoading = (state) => {
  return state.churn.loading
}
export const churnLastUpdate = (state) => {
  return state.churn.lastUpdate
}

export const goals = (state) => {
  return state.goals.data || []
}
export const goalsLoading = (state) => {
  return state.goals.loading
}
export const goalsLastUpdate = (state) => {
  return state.goals.lastUpdate
}

export const goalsManager = (state) => {
  return state.goalsManager.data || []
}
export const goalsManagerLoading = (state) => {
  return state.goalsManager.loading
}
export const goalsManagerLastUpdate = (state) => {
  return state.goalsManager.lastUpdate
}

export const statistics = (state) => {
  return state.statistics.data || []
}
export const statisticsLoading = (state) => {
  return state.statistics.loading
}
export const statisticsLastUpdate = (state) => {
  return state.statistics.lastUpdate
}

export const corporatePoll = (state) => {
  return state.corporatePoll.data || []
}
export const corporatePollLoading = (state) => {
  return state.corporatePoll.loading
}
export const corporatePollLastUpdate = (state) => {
  return state.corporatePoll.lastUpdate
}

export const userReturnDestination = (state) => {
  return state.userReturnDestination.url
}
export const bankDetails = (state) => {
  return state.bankDetails.data || []
}
export const bankDetailsLoading = (state) => {
  return state.bankDetails.loading
}
export const bankDetailsLastUpdate = (state) => {
  return state.bankDetails.lastUpdate
}

